import { render, staticRenderFns } from "./ForceChangeStatus.vue?vue&type=template&id=76bbb08c"
import script from "./ForceChangeStatus.vue?vue&type=script&lang=js"
export * from "./ForceChangeStatus.vue?vue&type=script&lang=js"
import style0 from "./ForceChangeStatus.vue?vue&type=style&index=0&id=76bbb08c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports